import moment from "moment";
import _ from "lodash";
import { BookingKitFilterState } from "./booking-kit-filter-state";

const datePaths = ["bookingDate.from", "bookingDate.to"];

export function parseSearchProfileFilters(
  filters: Partial<BookingKitFilterState>
): Partial<BookingKitFilterState> {
  const parsedFilters = { ...filters };

  for (const path of datePaths) {
    const value = _.get(parsedFilters, path);

    if (value) {
      _.set(parsedFilters, path, moment(value).toDate());
    }
  }

  return parsedFilters;
}
